<label data-test="OHNag2Yi" class="text-small mr-2" *ngIf="toggle">{{ label }}</label>
<label data-test="rIUOXQ9J" [ngClass]="{ checkbox: !toggle, switch: toggle }">
  <ng-content></ng-content>
  <ng-container *ngIf="toggle">
    <span data-test="HvPl2Ky8" class="switch__marker"></span>
  </ng-container>
  <ng-container *ngIf="!toggle">
    <span
      data-test="4u49zTFM"
      class="checkbox__label"
      *ngIf="showLabel"
      style="white-space: nowrap"
    >
      {{ label }}
    </span>
    <span data-test="afcGnF2M" class="checkbox__marker">
      <span data-test="UsAQCNvB" class="checkbox__marker-icon">
        <svg data-test="hF1F6Id5" class="icon__icon-check" width="9.07px" height="6.95px">
          <use xlink:href="#icon-check"></use>
        </svg>
      </span>
    </span>
  </ng-container>
</label>
